import { compileDayPlan } from "@zoidberg/brain";
import type { CallPayload } from "@zoidberg/contract";
import type { ProfileConfig } from "../api/config";
import type { SyncEvent } from "../api/cloud";

/**
 * Build a real payload from the user's config + real events from the API.
 * Falls back to empty day if no events are present.
 */
export function buildPayload(
  config: ProfileConfig,
  events: SyncEvent[],
  date: string
): CallPayload {
  const now = new Date();

  return compileDayPlan({
    date,
    timezone: config.timezone,
    events: events.map((e) => ({
      title: e.label,
      startMin: e.start_min ?? 9 * 60,
      outOfHouse: !!e.location,
      travelMin: e.is_fixed ? 30 : undefined,
      important: e.is_fixed,
    })),
    bedtimeMin: undefined, // TODO: get from sleep tracking
    weather: undefined,    // TODO: integrate weather API
    knownEntities: [],      // TODO: extract from events
    redactionLevel: config.redactionLevel,
    phones: config.phones,
    persona: {
      voiceId: "preview",
      label: config.persona.voiceLabel,
      speed: config.persona.speed,
      greetingEnergy: config.persona.greetingEnergy,
      hardWakeEnergy: "firm",
    },
    routineComfortMin: config.routine.comfortMin,
    routineMinimumMin: config.routine.minimumMin,
    generatedAt: now.toISOString(),
    expiresAt: new Date(now.getTime() + 7 * 864e5).toISOString(),
  });
}
